import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { LucideAngularModule, Tags } from 'lucide-angular';
import { InfoLineComponent } from '../info-line/info-line.component';

@Component({
  selector: 'app-keywords-info-line',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, InfoLineComponent],
  templateUrl: './keywords-info-line.component.html',
})
export class KeywordsInfoLineComponent {
  keywords = input.required<string[]>();
  additionalClasses = input<string>();

  protected readonly icon = Tags;
  protected readonly text = computed(() => {
    return this.keywords().join(', ');
  });
}
